export const text = '#404040';
export const hover = '#1961AC';
export const Black = '#000';
export const White = '#FFF';
